module.exports = __webpack_public_path__ + "static/media/received.102dacc7.mp3";